import React from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Grid,
  Drawer,
  makeStyles,
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import MobileSidebarComponent from "app/sidebar/MobileSidebarComponent";

import athenaLogo from "resources/logo-no-letters.png";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    [theme.breakpoints.up("xs")]: {
      visibility: "visible",
      marginBottom: "55px",
    },
    [theme.breakpoints.up("sm")]: {
      visibility: "visible",
      marginBottom: "55px",
    },
    [theme.breakpoints.up("md")]: {
      visibility: "visible",
      marginBottom: "55px",
    },
    [theme.breakpoints.up("lg")]: {
      visibility: "hidden",
      marginBottom: "0px",
    },
  },
  menuButton: {
    [theme.breakpoints.up("xs")]: {
      left: "20px",
    },
    [theme.breakpoints.up("sm")]: {
      left: "30px",
    },
    position: "absolute",
  },
  logo: {
    [theme.breakpoints.up("xs")]: {
      height: "25px",
    },
    [theme.breakpoints.up("sm")]: {
      height: "30px",
    },
    textAlign: "center",
  },
  appBar: {
    backgroundColor: "#181E2A",
  },
  toolBar: {
    justifyContent: "center",
  },
  drawerPaper: {
    zIndex: 4,
    backgroundColor: "#181E2A",
    width: "85vw",
  },
}));

function MenuComponent() {
  const classes = useStyles();

  const [open, setOpen] = React.useState(false);

  const toggleDrawer = (toggleValue) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setOpen(toggleValue);
  };
  return (
    <Grid item xs={12} className={classes.root}>
      <AppBar className={classes.appBar} position="fixed">
        <Toolbar className={classes.toolBar}>
          <IconButton
            edge="start"
            className={classes.menuButton}
            color="inherit"
            aria-label="menu"
            onClick={toggleDrawer(!open)}
          >
            <MenuIcon />
          </IconButton>
          <img className={classes.logo} src={athenaLogo} alt="Athena logo" />
        </Toolbar>
        <Drawer
          anchor="left"
          open={open}
          classes={{
            paper: classes.drawerPaper,
          }}
          onClose={toggleDrawer(false)}
        >
          <MobileSidebarComponent />
        </Drawer>
      </AppBar>
    </Grid>
  );
}

export default MenuComponent;
